import { Button } from "@astryxdesign/core/Button";
import { VStack } from "@astryxdesign/core/VStack";
import { useT } from "@/lib/i18n";

/** Yandex map widget (no API key): pinned at the entrance when coordinates are known, else found by address. */
function yandexMapWidget(address: string, geo?: [number, number]) {
  if (!geo) return `https://yandex.ru/map-widget/v1/?text=${encodeURIComponent(address)}&z=16`;
  const [lat, lon] = geo;
  return `https://yandex.ru/map-widget/v1/?ll=${lon},${lat}&z=16&pt=${lon},${lat},pm2rdm`;
}

/** Route from the visitor's location to the studio in Yandex Maps (app or site). */
function yandexRoute(address: string, geo?: [number, number]) {
  return `https://yandex.ru/maps/?rtext=~${geo ? geo.join(",") : encodeURIComponent(address)}&rtt=auto`;
}

/** Embedded Yandex map with a "how to get there" route button over its corner, like zapis.kz. */
export function StudioMap({ address, geo }: { address: string; geo?: [number, number] }) {
  const t = useT();
  return (
    <VStack className="map-wrap">
      <iframe className="map-frame" src={yandexMapWidget(address, geo)} title={t.about.mapTitle(address)} loading="lazy" allowFullScreen />
      <Button label={t.about.directions} variant="secondary" size="sm" className="map-route" href={yandexRoute(address, geo)} target="_blank" rel="noopener noreferrer" />
    </VStack>
  );
}
